<template>
  <div>
    <div
      class="flex items-center gap-0.5 p-0.5"
      :class="{
        'border-dashed border border-red-500 shadow-xl': item.editing,
      }"
    >
      <a class="el-icon-edit-outline text-sm" @click="toEdit" />
      <div
        v-if="!isEmptyData(item.operation.container_no)"
        :class="{ 'blur-xs': !item.operation.container_connected }"
        class="hover:blur-none"
      >
        {{ item.operation.container_no }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "order-status-yard-container",
  props: {
    item: Object,
    options: Object,
  },
  methods: {
    toEdit() {
      this.$set(this.item, "editing", !this.item.editing);
    },
  },
};
</script>
